'use client';

import * as stylex from '@stylexjs/stylex';
import { useContext } from 'react';
import '../../styles/tokens.stylex';
import { spacing } from '../../styles/tokens.stylex';
import { Button } from '../Buttons';
import { FormContext } from './context';
interface OnFormSubmittedProps {
  formId: string;
}
export function OnFormSubmitted({
  formId
}: OnFormSubmittedProps) {
  const {
    state,
    closeForm
  } = useContext(FormContext);
  const form = state?.forms.find(({
    id
  }) => formId === id);
  if (form?.isSubmitted && closeForm) {
    const close = () => closeForm(formId);
    return <div className="x78zum5 xl56j7k xlbpgpk xh5l0dc x1c4vz4f">
        <Button variant="solid" theme="secondary" onClick={close}>
          Close this window
        </Button>
      </div>;
  }
  return null;
}